import React, { useContext } from "react";
import { FormattedMessage } from "react-intl";
import { ReactComponent as FoldIcon } from "assets/images/icons/Fold.svg";
import { useStateMachine } from "little-state-machine";
import testIds from "constants/testIds";
import { handleSuggestionExpand } from "store/store";
import NavContext from "./NavContext";

interface SidebarProps {
  setIsExpanded: Function;
}

const ExpandMenu = function ({ setIsExpanded }: SidebarProps) {
  const { navigationConfig, setNavigationConfig } = useContext(NavContext);
  const { expanded } = navigationConfig;
  const { actions } = useStateMachine({ handleSuggestionExpand });

  const toggleNavigation = () => {
    setIsExpanded(!navigationConfig.expanded);
    setNavigationConfig({
      ...navigationConfig,
      expanded: !navigationConfig.expanded,
      isShown: navigationConfig.expanded && navigationConfig.isMobile ? false : navigationConfig.isShown,
    });
    navigationConfig.handleNavigation(navigationConfig.expanded);
    actions.handleSuggestionExpand({
      manageSuggestion: false,
    });
  };

  return (
    <div
      className="navigation-item"
      onClick={toggleNavigation}
      onKeyPress={toggleNavigation}
      role="button"
      tabIndex={0}
      data-testid={testIds.MENU_EXPAND_BUTTON}
    >
      <FoldIcon
        style={{
          transform: navigationConfig.expanded ? "rotate(0deg)" : "rotate(180deg)",
          transition: "transform 0.2s ease-out",
        }}
      />
      {expanded && (
        <span className="navigation-item-label">
          <FormattedMessage id="general.foldSidebar" defaultMessage="Fold Sidebar" />
        </span>
      )}
    </div>
  );
};

export default ExpandMenu;
